/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class AccountGroupGrid extends SiteEntityGrid<AccountGroupRow, any> {
        protected getColumnsKey() { return 'Data.AccountGroup'; }
        protected getDialogType() { return AccountGroupDialog; }
        protected getIdProperty() { return AccountGroupRow.idProperty; }
        protected getLocalTextPrefix() { return AccountGroupRow.localTextPrefix; }
        protected getService() { return AccountGroupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}